<template>
  <div class="strategys-time-content" v-loading="loading">
    <div class="head_body" style="padding-top: 10px;">
      <el-form ref="form" :model="filter" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="5">
            <el-form-item :label="$t('lampStrategy.strategy_name')">
              <el-input v-model="filter.title" :placeholder="$t('lampStrategy.input_strategy_name')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('lampStrategy.strategy_type')">
              <el-select
                clearable
                :placeholder="$t('lampStrategy.select_strategy_type')"
                v-model="filter.run_model"
                style="width: 100%"
              >
                <el-option key="all" :label="$t('control.all')" value=""></el-option>
                <el-option :key="1" :label="$t('lampStrategy.system_strategy')" :value="1"></el-option>
                <el-option :key="2" :label="$t('lampStrategy.offline_strategy')" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('lampStrategy.mode')">
              <el-select
                clearable
                :placeholder="$t('lampStrategy.select_mode')"
                v-model="filter.is_double"
                style="width: 100%"
              >
                <el-option key="all" :label="$t('control.all')" value=""></el-option>
                <el-option :key="0" :label="$t('device.single')" :value="0"></el-option>
                <el-option :key="1" :label="$t('device.double')" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
        <div class="group-tip">{{$t('lampStrategy.time_strategy_tip')}}</div>
      </div>
      <div class="h20"></div>
      <table class="diy-table">
        <thead>
          <tr>
            <th width="280"><div class="cell">{{$t('lampStrategy.strategy_name')}}</div></th>
            <th width="200"><div class="cell">{{$t('lampStrategy.mode')}}</div></th>
            <th width="200"><div class="cell">{{$t('lampStrategy.strategy_type')}}</div></th>
            <th><div class="cell times">{{$t('control.start_time')}}<div class="icon"><svg-icon name="between"/></div>{{$t('control.over_time')}}</div></th>
            <th width="250"><div class="cell">{{$t('device.light')}}</div></th>
            <th width="250"><div class="cell">{{$t('control.operate')}}</div></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item,index) in tableData">
              <template v-if="item.is_double">
                <tr>
                  <td rowspan="2"><div class="cell">{{item.title}}</div></td>
                  <td rowspan="2"><div class="cell">{{ doubleType[item.is_double]}}</div></td>
                  <td rowspan="2"><div class="cell">{{ modelType[item.run_model] }}</div></td>
                  <td>
                    <div v-if="item.stg_list.length" class="cell times">
                      <div class="time1"><span class="w-label">{{$t('device.lamp1')}}：</span> {{ item.stg_list[0].time[0] }}</div>
                      <div class="icon"><svg-icon name="between"/></div>
                      <div class="time2">{{item.stg_list[0].time[1]}}</div>
                    </div>
                    <div v-else class="cell">-</div>
                  </td>
                  <td>
                    <div v-if="item.stg_list.length" class="cell">{{ item.stg_list[0].light }}%</div>
                    <div v-else class="cell">-</div>
                  </td>
                  <td rowspan="2">
                    <div class="cell">
                      <div class="table-last normal">
                        <span @click="(loading = true), openEditWin(item)" class="blue pointer mar-r15">{{$t('control.edit')}}</span>
                        <span @click="delItem(item.id)" class="blue pointer">{{$t('control.delete')}}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="sub-tr">
                  <td>
                    <div v-if="item.stg_list.length" class="cell times">
                      <div class="time1"><span class="w-label">{{$t('device.lamp2')}}：</span> {{item.stg_list[0].time2[0]}}</div>
                      <div class="icon"><svg-icon name="between"/></div>
                      <div class="time2">{{item.stg_list[0].time2[1]}}</div>
                    </div>
                    <div v-else class="cell">-</div>
                  </td>
                  <td>
                    <div v-if="item.stg_list.length" class="cell">{{ item.stg_list[0].light2 }}%</div>
                    <div v-else class="cell">-</div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="double0">
                  <td><div class="cell">{{item.title}}</div></td>
                  <td><div class="cell">{{ doubleType[item.is_double]}}</div></td>
                  <td><div class="cell">{{ modelType[item.run_model] }}</div></td>
                  <td>
                    <div v-if="item.stg_list.length" class="cell times">
                      <div class="time1"><span class="w-label">　</span> {{ item.stg_list[0].time[0] }}</div>
                      <div class="icon"><svg-icon name="between"/></div>
                      <div class="time2">{{ item.stg_list[0].time[1] }}</div>
                    </div>
                    <div v-else class="cell">-</div>
                  </td>
                  <td>
                    <div v-if="item.stg_list.length" class="cell">{{ item.stg_list[0].light }}%</div>
                    <div v-else class="cell">-</div>
                  </td>
                  <td>
                    <div class="cell">
                      <div class="table-last normal">
                        <span @click="(loading = true), openEditWin(item)" class="blue pointer mar-r15">{{$t('control.edit')}}</span>
                        <span @click="delItem(item.id)" class="blue pointer">{{$t('control.delete')}}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
          </template>
        </tbody>
      </table>
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    

    <!--新增修改路灯策略 开始-->
    <el-dialog
      v-if="dialogVisible"
      class="normal_dialog dialog860"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="editOne"
        ref="editOneRef"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-row :gutter="20" class="item-list">
            <el-col :span="10">
              <el-form-item :label="$t('lampStrategy.strategy_name')" prop="title">
                <el-input v-model="editOne.title" :placeholder="$t('lampStrategy.input_strategy_name')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('lampStrategy.mode')">
                <el-select
                  :placeholder="$t('lampStrategy.select_mode')"
                  v-model="editOne.is_double"
                  style="width: 100%"
                  @change="changeDouble" 
                  :disabled="editType === 'create'?false:true"
                >
                  <el-option
                    v-for="(t,index) in doubleType"
                    :key="index"
                    :label="t"
                    :value="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('lampStrategy.strategy_type')">
                <el-select
                  :placeholder="$t('lampStrategy.strategy_type')"
                  v-model="editOne.run_model"
                  style="width: 100%"
                  @change="changeRunMode"
                  :disabled="editType === 'create'?false:true"
                >
                  <el-option :key="1" :label="$t('lampStrategy.system_strategy')" :value="1"></el-option>
                  <el-option :key="2" :label="$t('lampStrategy.offline_strategy')" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="insert-strategy">
            <div class="time-tips">
              <div class="sub-title">{{$t('lampStrategy.time_table')}}</div>
              <el-button
                v-if="editOne.is_double"
                type="primary"
                size="small"
                @click="setLight2"
                class="set-light2"
                >
                {{$t('lampStrategy.set_lamp2')}}
              </el-button>
            </div>
            <ul class="t-head">
              <li>{{$t('lampStrategy.number')}}</li>
              <li>{{$t('control.number')}}</li>
              <li v-if="editOne.run_model==1" class="times">{{$t('control.start_time')}}<div class="icon"><svg-icon name="between"/></div>{{$t('control.over_time')}}</li>
              <li v-else class="times">{{$t('control.time')}}</li>
              <li>{{$t('device.light')}}(%)</li>
              <li>{{$t('control.operate')}}</li>
            </ul>
            <div v-for="(item,index) in editOne.stg_list" :key="editOne.run_model+'-'+item.key" class="item-box">
              <div v-show="editOne.is_double" class="item double">
                <div class="bh">{{toOrder(index+1)}}</div>
                <div class="number">
                  <div class="line">{{$t('device.lamp1')}}</div>
                  <div class="line">{{$t('device.lamp2')}}</div>
                </div>
                <div v-show="editOne.run_model===1" class="lamp-time">
                  <div class="line">
                    <el-time-picker
                      :name="'dpicker_model1'+item.key"
                      is-range
                      v-model="item.time"
                      format='HH:mm'
                      :start-placeholder="$t('control.any_date')"
                      :end-placeholder="$t('control.any_date')"
                      :placeholder="$t('control.select_time')"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                  <div class="line">
                    <el-time-picker
                      :name="'dpicker2_model1'+item.key"
                      is-range
                      v-model="item.time2"
                      format='HH:mm'
                      :start-placeholder="$t('control.any_date')"
                      :end-placeholder="$t('control.any_date')"
                      :placeholder="$t('control.select_time')"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                </div>
                <div v-show="editOne.run_model===2" class="lamp-time">
                  <div class="line">
                    <el-time-picker
                      :name="'dpicker_model2'+item.key"
                      v-model="item.timeline"
                      format='HH:mm'
                      :placeholder="$t('control.select_time')"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                  <div class="line">
                    <el-time-picker
                      :name="'dpicker2_model2'+item.key"
                      v-model="item.timeline2"
                      format='HH:mm'
                      :placeholder="$t('control.select_time')"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                </div>
                <div class="lamp-light">
                  <div class="line">
                    <el-input-number
                      controls-position="right"
                      v-model="item.light"
                      :min="0"
                      :max="100"
                      class="strategy_number"
                    >
                    </el-input-number>
                  </div>
                  <div class="line">
                    <el-input-number
                      controls-position="right"
                      v-model="item.light2"
                      :min="0"
                      :max="100"
                      class="strategy_number"
                    >
                    </el-input-number>
                  </div>
                </div>
                <div class="addDel">
                  <div class="item-btn" @click="removeTime(index)"><i class="el-icon-remove"></i></div>
                  <div class="item-btn" @click="addTime"><i class="el-icon-circle-plus"></i></div>
                </div>
              </div>
              <div v-show="!editOne.is_double" class="item">
                <div class="bh">{{toOrder(index+1)}}</div>
                <div class="number">{{$t('device.lamp1')}}</div>
                <div class="lamp-time">
                  <div v-show="editOne.run_model===1" class="line">
                    <el-time-picker
                      :name="'picker_mode1'+item.key"
                      :clearable="false"
                      is-range
                      v-model="item.time"
                      format='HH:mm'
                      :start-placeholder="$t('control.any_date')"
                      :end-placeholder="$t('control.any_date')"
                      :placeholder="$t('control.select_time')"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                  <div v-show="editOne.run_model==2" class="line">
                    <el-time-picker
                      :name="'picker_mode2'+item.key"
                      :clearable="false"
                      v-model="item.timeline"
                      format='HH:mm'
                      :placeholder="$t('control.select_time')"
                      style="width: 100%"
                    >
                    </el-time-picker>
                  </div>
                </div>
                <div class="lamp-light">
                  <div class="line">
                    <el-input-number
                      controls-position="right"
                      v-model="item.light"
                      :min="0"
                      :max="100"
                      class="strategy_number"
                    >
                    </el-input-number>
                  </div>
                </div>
                <div class="addDel">
                  <div class="item-btn" @click="removeTime(index)"><i class="el-icon-remove"></i></div>
                  <div class="item-btn" @click="addTime"><i class="el-icon-circle-plus"></i></div>
                </div>
              </div>
            </div>

          </div>
      
          <div class="lamp-transfer strategy-transfer">
            <el-transfer
              filterable
              :filter-placeholder="$t('lampStrategy.input_lamp_name')"
              :data="allDevices"
              :titles="[$t('lampStrategy.lamp_can'), $t('lampStrategy.lamp_have')]"
              :button-texts="[$t('control.remove'), $t('control.add')]"
              v-model="allocated"
            >
            </el-transfer>
          </div>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">{{$t('control.cancel')}}</el-button>
          <el-button v-if="editType === 'create'" type="primary" size="medium" @click="createItem">{{$t('control.confirm')}}</el-button>
          <el-button v-if="editType === 'update'" type="primary" size="medium" @click="updateItem">{{$t('control.confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增修改路灯策略 结束 -->
  </div>
</template>
<script>
import commonJs from '@/utils/common'
import time from "@/utils/time";
import moment from "moment";
import strategyApi from "@/api/device/strategy"
export default {
  name: "strategyTime",
  props:['stgId'],
  data() {
    return {
      loading: false,
      doubleType: this.$t('device.doubleType'),
      modelType: this.$t('lampStrategy.modelType'),
      tableData: [],
      pageInfo: {
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        strategy_type: 1,
        title: '',
        run_model: '',
        is_double: ''
      },
      cnt_all: 0,
      dialogVisible: false,
      editOneRule: {
        title: [{ required: true, message: this.$t('lampStrategy.input_strategy_name'), trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        id: '',
        title: '',
        is_double: 0,
        strategy_type: 1,
        run_model: 1,
        stg_list: [
          {
            key: Date.now(),
            light: 0,
            light2: 0,
            time: [this.numberToTime(0), this.numberToTime(3600)],
            time2: [this.numberToTime(0), this.numberToTime(3600)],
            timeline: '',
            timeline2: ''
          }
        ]
      },
      allDevices: [],
      allocated: []
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
    if(this.stgId){
      this.strategyInfo(this.stgId)
    }
  },
  methods: {
    ...time,
    getTableData(pageIndex) {
      this.tableData = []
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      strategyApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      })
    },
    strategyInfo(stgId) {
      strategyApi.getStrategyInfo(stgId).then((res) => {
        if (res.data.code === 1000) {
          let index = res.data.data
          if(index.id){
            this.editOne = {
              id: index.id,
              title: index.title,
              run_model: 1,
              is_double: index.is_double,
              strategy_type: 1,
              stg_list: []
            };
            this.editType = "update";
            this.getStgTime(index.id, index.is_double, index.run_model, index.stg_list)
            this.getLampList(0);
            this.dialogVisible = true;
            this.loading = false;
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    changeDouble(){
      this.getLampList(0)
    },
    openEditWin(index) {
      this.allDevices = []
      this.allocated = []
      if (index === "create") {
        this.editOne = {
          id: '',
          title: '',
          is_double: 0,
          run_model: 1,
          strategy_type: 1,
          stg_list: [
            {
              key: Date.now(),
              light: 0,
              light2: 0,
              time: [this.numberToTime(0), this.numberToTime(3600)],
              time2: [this.numberToTime(0), this.numberToTime(3600)],
              timeline: '',
              timeline2: ''
            }
          ]
        };
        this.editType = "create";
        this.dialogVisible = true;
        this.loading = false;
      } else {
        this.editOne = {
          id: index.id,
          title: index.title,
          run_model: index.run_model,
          is_double: index.is_double,
          strategy_type: 1,
          stg_list: []
        };
        this.editType = "update";
        this.getStgTime(index.id, index.is_double, index.run_model, index.stg_list)
        setTimeout(() => {
          this.dialogVisible = true;
          this.loading = false;
        }, 200)
      }
      this.getLampList(0);
    },
    getStgTime(id,is_double, run_model, arr) {
      for (let i=0; i<arr.length; i++) {
        let time2 = []
        let timeline2 = ''
        let light2 = 0
        if(is_double){
          if(run_model===1){
            time2 = [this.numberToTime(this.HmToNumber(arr[i].time2[0])), this.numberToTime(this.HmToNumber(arr[i].time2[1]))]
          }else{
            timeline2= this.numberToTime(this.HmToNumber(arr[i].time2))
          }
          light2 = arr[i].light2
        }
        let item_one = {
          key: parseInt(id+'0'+i),
          time: run_model===1?[this.numberToTime(this.HmToNumber(arr[i].time[0])), this.numberToTime(this.HmToNumber(arr[i].time[1]))]:[],
          time2: time2,
          timeline: run_model===2?this.numberToTime(this.HmToNumber(arr[i].time)):'',
          timeline2: timeline2,
          light: parseInt(arr[i].light),
          light2: parseInt(light2)
        }
        this.$set(this.editOne.stg_list, i, item_one)
      }
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    addTime() {
      if(this.editOne.run_model==2&&this.editOne.stg_list.length>5){
        return this.$message.error(this.$t('lampStrategy.offline_must6'));
      }
      this.editOne.stg_list.push({
        key: Date.now(),
        light: 0,
        light2: 0,
        time: [this.numberToTime(0), this.numberToTime(3600)],
        time2: [this.numberToTime(0), this.numberToTime(3600)],
        timeline: '',
        timeline2: ''
      });
    },
    removeTime(index) {
      if(this.editOne.stg_list.length<=1){
        return this.$message.error(this.$t('lampStrategy.time_table_must1'));
      }
      if (confirm(this.$t('lampStrategy.delect_time_table'))) {
        this.editOne.stg_list.splice(index, 1);
      }
    },
    createItem() {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          const stg_list = this.editOne.stg_list
          const run_model = this.editOne.run_model
          // console.log('stg_list', stg_list)
          if(stg_list.length<1){
            return this.$message.error(this.$t('lampStrategy.time_table_must1'));
          }

          if(run_model===2&&stg_list.length>6){
            return this.$message.error(this.$t('lampStrategy.offline_must6'));
          }
          if(run_model===2&&stg_list.length<2){
            return this.$message.error(this.$t('lampStrategy.offline_must2'));
          }

          if(run_model===2&&stg_list[0].light<1){
            return this.$message.error(this.$t('lampStrategy.no1_tip'));
          }
          if(run_model===2&&stg_list[1].light){
            return this.$message.error(this.$t('lampStrategy.no1_tip2'));
          }
          
          let params = {
            title: this.editOne.title,
            is_double: this.editOne.is_double,
            run_model: run_model,
            strategy_type: 1,
            stg_list: [],
            ids: ''
          }

          if(this.allocated.length){
            params.ids=this.allocated.toString();
          }


          let newStg_list= []
          for(let i =0; i<stg_list.length; i++){
            let item_one = {}
            if(run_model===1){
              item_one = {
                light: stg_list[i].light,
                light2: stg_list[i].light2,
                time: [moment(stg_list[i].time[0]).format("HH:mm"),moment(stg_list[i].time[1]).format("HH:mm")],
                time2: [moment(stg_list[i].time2[0]).format("HH:mm"), moment(stg_list[i].time2[1]).format("HH:mm")]
              }
            }else{
              item_one = {
                light: stg_list[i].light,
                light2: stg_list[i].light2,
                time: moment(stg_list[i].timeline).format("HH:mm"),
                time2: stg_list[i].timeline2?moment(stg_list[i].timeline2).format("HH:mm"):''
              }
            }
            newStg_list[i] = item_one
          }
          params.stg_list = JSON.stringify(newStg_list);
          strategyApi.strategyAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        } else {
          return false
        }
      })

    },
    updateItem() {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          let stg_list = this.editOne.stg_list
          const run_model = this.editOne.run_model
          if(stg_list.length<1){
            return this.$message.error(this.$t('lampStrategy.time_table_must1'));
          }

          if(run_model==2&&stg_list.length>6){
            return this.$message.error(this.$t('lampStrategy.offline_must6'));
          }
          if(run_model==2&&stg_list.length<2){
            return this.$message.error(this.$t('lampStrategy.offline_must2'));
          }

          
          let params = {
            id: this.editOne.id,
            title: this.editOne.title,
            is_double: this.editOne.is_double,
            run_model: run_model,
            strategy_type: 1,
            stg_list: [],
            ids: ''
          }

          if(this.allocated.length){
            params.ids=this.allocated.toString();
          }

          let newStg_list= []
          for(let i =0; i<stg_list.length; i++){
            let item_one = {}
            if(run_model===1){
              item_one = {
                light: stg_list[i].light,
                light2: stg_list[i].light2,
                time: [moment(stg_list[i].time[0]).format("HH:mm"),moment(stg_list[i].time[1]).format("HH:mm")],
                time2: [moment(stg_list[i].time2[0]).format("HH:mm"), moment(stg_list[i].time2[1]).format("HH:mm")]
              }
            }else{
              item_one = {
                light: stg_list[i].light,
                light2: stg_list[i].light2,
                time: moment(stg_list[i].timeline).format("HH:mm"),
                time2: stg_list[i].timeline2?moment(stg_list[i].timeline2).format("HH:mm"):''
              }
            }
            newStg_list[i] = item_one
          }
          params.stg_list = JSON.stringify(newStg_list);
          strategyApi.strategyEdit(this.editOne.id, params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.mod_success'))
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    },
    changeRunMode(e) {
      // console.log('e', e)
      let strategy_id = 0
      if(this.editOne.id){
        strategy_id = this.editOne.id
      }
      if(e==2){
        this.editOne.stg_list = [
          {
            key: Date.now(),
            light: 80,
            light2: 80,
            time: [this.numberToTime(0), this.numberToTime(3600)],
            time2: [this.numberToTime(3600), this.numberToTime(3600*2)],
            timeline: this.numberToTime(3600*18),
            timeline2: this.numberToTime(3600*18)
          },
          {
            key: Date.now()+2,
            light: 0,
            light2: 0,
            time: [this.numberToTime(0), this.numberToTime(3600)],
            time2: [this.numberToTime(3600), this.numberToTime(3600*2)],
            timeline: this.numberToTime(3600*6),
            timeline2: this.numberToTime(3600*6)
          }
        ]
      }else{
        this.editOne.stg_list = [
          {
            key: Date.now(),
            light: 0,
            light2: 0,
            time: [this.numberToTime(0), this.numberToTime(3600)],
            time2: [this.numberToTime(0), this.numberToTime(3600)],
            timeline: '',
            timeline2: ''
          }
        ]
      }
      this.getLampList(strategy_id)
    },
    setLight2() {
      const stg_list = this.editOne.stg_list
      if(stg_list.length<1){
        return this.$message.error(this.$t('lampStrategy.please_set_lamp1'));
      }
      for(let i = 0; i<stg_list.length; i++){
        this.editOne.stg_list[i].light2 = stg_list[i].light
        this.editOne.stg_list[i].time2 = stg_list[i].time
        this.editOne.stg_list[i].timeline2 = stg_list[i].timeline
      }
      
    },
    getLampList(id) {
      let that = this
      strategyApi.getLampAndGroupByStrategy({
        is_double: that.editOne.is_double,
        strategy_id: id,
        strategy_type: 1,
        run_model: that.editOne.run_model,
        page: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.data.code === 1000) {
          let arrData = []
          let resData = res.data.data
          if(resData.length){
            for (const lamp of resData) {
              arrData.push({
                key: lamp.id+'_'+lamp.type,
                label: lamp.name+'-'+lamp.number
              })
            }
          }
          that.allocated = []
          if(id){
            if(arrData.length){
              for (const item of arrData) {
                that.allocated.push(item.key)
              }
              that.allDevices = [...that.allDevices, ...arrData]
              that.allDevices = Array.from(new Set(that.allDevices))
            }
          }else{
            that.allDevices = arrData
            if(that.editOne.id){
              that.getLampList(that.editOne.id)
            }
          }
        }
      })
    },

    delItem(id) {
      this.$confirm(this.$t('lampStrategy.delete_strategy_tip'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          strategyApi.strategyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$popupMessage({
                type: 'success',
                title: this.$t('control.del_success')
                // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
              })
              this.getTableData(this.pageInfo.page);
            } else {
              this.$popupMessage({
                type: 'error',
                title: this.$t('control.tip'),
                msg: res.data.message
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    toOrder(index){
      if(index<10){
        return '0'+index
      }else{
        return index
      }
    }
  }
  
};
</script>
<style lang='less'>
@color-primary:#336b96;
.strategys-time-content{
  padding:0 0 20px;
  .con-body{
    padding:20px 0 10px !important;
  }
  .diy-table{
    width:100%;
    border: 0;
    border-collapse: collapse;
    border-spacing: 0;
    color: #1d2129;
    tr{
      margin:0;
      padding: 0;
      border: 0;
      th,td{
        border: 0;
        border-right: 1px solid #dee0e4;
        border-bottom: 1px solid #dee0e4;
        padding: 20px 0;
        min-width: 0;
        word-break: break-all;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        background-clip: padding-box; /* Add this line */
        .cell{
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
          line-height: 1.4;
          padding:5px 10px;
          font-size: 14px;
          text-align: center;
          &.times{
            display: flex;
            align-items: center;
            justify-content: center;
            .icon{
              margin: 0 20px;
              font-weight: normal;
            }
          }
        }
        &:last-child{
          border-right: 1px solid transparent;
        }
      }
      
      th{
        background-color: #f5f7f9;
        border-right: 1px solid #f5f7f9;
        border-bottom: 1px solid #dee0e4;
        .cell{
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      td{
        .time1{
          width:160px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .time2{
          width:160px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .icon{
          color:#bbb;
        }
        .w-label{
          width:80px !important;
          text-align: right;
          display: block;
        }
      }

      
      &.sub-tr{
        td{
          &:last-child{
            border-right: 1px solid #dee0e4;
          }
        }
      }
      &.double0{
        td{
          background-color: rgba(246,255,255,.6);
        }
      }
    }
  }
  .insert-strategy{
    color:#1d2129;
    padding-bottom: 20px;
    .time-tips{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 15px;
      .set-light2{
        height:30px;
        background-color: #336b96;
        color:#fff;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover{
          background-color: #1f4f74 !important;
          border-color: #1f4f74 !important;
        }
      }
    }
    
    .t-head{
      width:100%;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      background-color: #f6f7fb;
      li{
        height:40px;
        display: flex;
        align-items: center;
        justify-content: center;
        width:60px;
        &:nth-child(3){
          flex: 1;
          min-width: 300px;
        }
        &:nth-child(4),&:nth-child(5){
          width:150px;
        }
        &.times{
          display: flex;
          align-items: center;
          justify-content: center;
          .icon{
            margin: 0 20px;
            font-weight: normal;
          }
        }
      }
    }
    .item-box{
      width:100%;
      border-bottom: 1px solid #dcdee2;
      .item{
        height:40px;
        display: flex;
        .bh,.number,.lamp-time,.lamp-light,.addDel{
          width:60px;
          height:40px;
          border-right:1px solid #dcdee2;
          display:flex;
          align-items:center;
          justify-content:center;
        }
        &.double{
          height:81px;
          .bh,.number,.lamp-time,.lamp-light,.addDel{
            height:81px;
            flex-direction: column;
            .line{
              width:100%;
              height:50%;
              display:flex;
              align-items:center;
              justify-content:center;
              box-sizing: border-box;
              overflow: hidden;
              &:last-child{
                border-top:1px solid #dcdee2;
              }
            }
          }
          .addDel{
            flex-direction: row;
          }

        }

        .lamp-time{
          flex: 1;
          min-width: 260px;
          .line{
            position:relative;
            z-index: 3;
          }
        }
        .lamp-light{
          width:150px;
        }
        .addDel{
          width:150px;
          border-right-color:#ffffff;
          .item-btn{
            width:25px;
            height:25px;
            color:@color-primary;
            font-size:22px;
            display:flex;
            align-items:center;
            justify-content:center;
            cursor:pointer;
            margin:0 8px;
          }
        }
      }
    }
  }
  
}

.lamp-time{
  .el-input__inner{
    border:0;
    display:flex;
    align-items:center;
    justify-content: center;
    position:relative;
    .el-icon-time,.el-range__close-icon{
      position:absolute;
      right:10px;
      top:50%;
      transform: translateY(-50%);
    }
    .el-range-input{
      font-size:14px;
      font-family:arial;
      color:#111;
      width:28%;
    }
    
    .el-range__close-icon{
      right:35px;
    }
    .el-range-separator{
      width:45px;
      height:34px;
      text-indent:-2222em;
      position:relative;
      &::after{
        content: '';
        width:16px;
        height:5px;
        position:absolute;
        top:50%;
        margin-left:-8px;
        left:50%;
        margin-top:-2.5px;
        background: url(../../../assets/images/between.png) center center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.strategy_number{
  position:relative;
  width:100%;
  height:40px;
  .el-input__inner{
    border:0;
    font-size:14px;
    font-family:arial;
    color:#111;
  }
  .el-input-number__decrease,.el-input-number__increase{
    width:28px !important;
    height:20px !important;
    border-top:0 !important;
    box-sizing:border-box;
    right:0 !important;
    display:flex;
    align-items:center;
    justify-content:center;
    background: none !important;
    font-size:16px;
    top:0 !important;
    z-index: 9999;
  }
  .el-input-number__decrease{
    top: auto !important;
    bottom:0 !important;
  }
}

.strategy-transfer{
  .el-transfer__buttons{
    .el-transfer__button{
      left:100px !important;
      &:first-child{
        left: auto !important;
        right:100px !important;
      }
    }
  }
}

.w-label{
  width:50px;
  text-align: right;
  display: block;
}
</style>
